import muiIcons from "../../../components/icons/mui-icons";

export const titleCardData = [
  {
    Icon: muiIcons.PersonIcon,
    name: "30.2k",
    title: "Total Follower",
    percent: 12.6,
  },
  {
    Icon: muiIcons.StarIcon,
    name: "9.2k",
    title: "Impression",
    percent: 12.6,
  },
  {
    Icon: muiIcons.LinkIcon,
    name: "1.2k",
    title: "Connect",
    percent: 12.6,
  },
  {
    Icon: muiIcons.StarsIcon,
    name: "18.2k",
    title: "Rate Review",
    percent: 12.6,
  },
];

export const socialPostData = [
  {
    subTitle: "Adventure sports",
    title: "Fear Of Driving And Automatic Negative Toughts",
    photoUrl: "/assets/images/social-post/post1.png",
  },
  {
    subTitle: "Sales And Operations",
    title: "Work more, Earn more while sitting at your home",
    photoUrl: "/assets/images/social-post/post2.png",
  },
  {
    subTitle: "Tech",
    title: "Next gen smartphones for 2022 by apple",
    photoUrl: "/assets/images/social-post/post3.png",
  },
  {
    subTitle: "Food",
    title: "momos are the best way to enjoy your weekend",
    photoUrl: "/assets/images/social-post/post4.png",
  },
];

export const titleCard2Data = [
  {
    Icon: muiIcons.NetworkIcon,
    name: "30.2k",
    title: "Reach",
    percent: 12.6,
  },
  {
    Icon: muiIcons.HeartIcon,
    name: "9.2k",
    title: "Avg. Likes Recieved",
    percent: 12.6,
  },
  {
    Icon: muiIcons.DocumentIcon,
    name: "1.2k",
    title: "Feedback",
    percent: 12.6,
  },
  {
    Icon: muiIcons.DocumentIcon,
    name: "18.2k",
    title: "Avg. Feedback",
    percent: 12.6,
  },
];
